module.exports = __webpack_public_path__ + "assets/73b9f58bda1d482b378030f3771f4520.svg";